import { Device } from '@services/devices'
import { LogLevel } from '@utils/globals/globals'

export interface Agent {
    id: number
    name: string
    isEnabled: boolean
    tenantId: string
    devices?: Device[]
    machines?: AgentMachine[]
}

export interface DetailsAgentRequest {
    name: string
    isEnabled: boolean
    tenantId: string
}

export interface AgentMachine {
    id: number
    agentId: number
    machineName: string
    domainName: string
    version: string
    lastUpdateTimestamp?: Date
}

export interface LogEntry {
    id: string
    agentId: number
    level: LogLevel
    message: string
    createdAt: Date
    exceptionMessage?: string
    exceptionStackTrace?: string
    innerExceptionMessage?: string
    innerExceptionStackTrace?: string
}

export interface AgentDebugRequest {
    agentId: number
    logLevel: LogLevel
    isTroubleshooting: boolean
}

export interface AgentDebugStatus {
    agentId: number
    logLevel: LogLevel
    isTroubleshooting: boolean
    troubleshootingStartedAt?: Date
    logs: LogEntry[]
    totalLogs: number
    name: string
    version: string
    hostname: string
}

export const getLevelColor = (level: LogLevel) => {
    switch (level) {
        case 'Trace':
        case 'Debug':
            return 'primary'
        case 'Information':
            return 'hollow'
        case 'Warning':
            return 'warning'
        case 'Error':
        case 'Critical':
            return 'danger'
        default:
            return 'default'
    }
}

export const getLevelTag = (level: LogLevel) => {
    switch (level) {
        case 'Trace':
            return 'TRACE'
        case 'Debug':
            return 'DEBUG'
        case 'Information':
            return 'INFO'
        case 'Warning':
            return 'WARN'
        case 'Error':
            return 'ERROR'
        case 'Critical':
            return 'FATAL'
        default:
            return 'UNKNOWN'
    }
}
